import markupProvider from './cardData/provider';
import { lazyLoadComponent } from '../../utils';

export default async (id) => {
    const namespace = 'SidepanelModalCard';
    const Card = await lazyLoadComponent(namespace, 'Card');
    let props = {};
    switch (id) {
    case 'infoMAP':
        props = {
            rows: [
                {
                    component: await lazyLoadComponent(namespace, 'ContentRow'),
                    props: {
                        id: 'info_about',
                        title: 'Informace o aplikaci Mapka',
                        body: await markupProvider('info_about'),
                    },
                },
            ]
        };
        break;
    case 'howto':
        props = {
            rows: [
                {
                    component: await lazyLoadComponent(namespace, 'ContentRow'),
                    props: {
                        id: 'howto',
                        title: 'Jak pracovat s Mapkou',
                        body: await markupProvider('howto'),
                    },
                },
            ]
        };
        break;
    default:
        break;
    }

    return new Card(props);
};
